<div class="project-table-wrapper">
  <div class="project-table">
    <!-- ONE column list, not two. The header and every row derive their tracks from
         the same model.columns, so a header and a body cannot disagree. -->
    <div class="table-header" [style.grid-template-columns]="gridTemplateColumns">
      <!-- A header is a BUTTON, not a div with a click handler: it is an action, so
           it must be reachable by keyboard and announce itself as one. -->
      <button
        type="button"
        class="header-cell"
        [ngClass]="columnClassAt(i)"
        *ngFor="let column of model.columns; let i = index"
        [class.sorted]="!!indicatorFor(column.id)"
        [attr.aria-sort]="indicatorFor(column.id) ? (indicatorFor(column.id)!.direction === 'asc' ? 'ascending' : 'descending') : 'none'"
        [title]="'Sort by ' + column.label + ' (shift-click to add to the sort)'"
        (click)="onHeaderClick(column.id, $event)">
        <span class="header-label">{{ column.label }}</span>
        <span class="sort-glyph">{{ sortGlyph(column.id) }}</span>
      </button>
    </div>

    <!-- Per-column filters. One row, always present rather than behind a toggle: a
         filter you cannot see is a filter you forget you set, and "why is the grid
         empty" is the support call that follows. -->
    <div class="filter-row" [style.grid-template-columns]="gridTemplateColumns">
      <div class="filter-cell" [ngClass]="columnClassAt(i)" *ngFor="let column of model.columns; let i = index">
        <!-- A column with a FIXED vocabulary gets a chooser, not a text box: the
             operator should not have to know the exact wording, and typing "act"
             would silently match both "Active" and "Active (Free)". -->
        <ng-container *ngIf="column.filterType === 'enum'; else textFilter">
          <div class="enum-filter" [class.open]="openEnumFilter === column.id">
            <button
              type="button"
              class="filter-input enum-trigger"
              [attr.aria-expanded]="openEnumFilter === column.id"
              [attr.aria-label]="'Filter by ' + column.label"
              (click)="toggleEnumFilter(column.id, $event)">
              <span class="enum-summary">{{ enumSummary(column) }}</span>
              <span class="enum-caret" aria-hidden="true">▾</span>
            </button>

            <div class="enum-menu" *ngIf="openEnumFilter === column.id" (click)="$event.stopPropagation()">
              <!-- "All" is a CLEAR, not a select-everything: an empty filter and
                   one naming every value mean the same thing to the model, and
                   storing the empty one keeps a saved view from pinning a
                   vocabulary that may grow. -->
              <label class="enum-option enum-all">
                <input
                  type="checkbox"
                  [checked]="isEnumAll(column.id)"
                  (change)="clearEnumFilter(column.id)" />
                <span>{{ 'ProjectGridAll' | t }}</span>
              </label>
              <label class="enum-option" *ngFor="let option of column.enumOptions">
                <input
                  type="checkbox"
                  [checked]="isEnumSelected(column.id, option.value)"
                  (change)="toggleEnumValue(column.id, option.value)" />
                <span>{{ option.labelKey ? (option.labelKey | t) : option.value }}</span>
              </label>
            </div>
          </div>
        </ng-container>

        <ng-template #textFilter>
          <input
            class="filter-input"
            type="text"
            [value]="filterValue(column.id)"
            [attr.aria-label]="'Filter by ' + column.label"
            [placeholder]="'Filter ' + column.label"
            (input)="onFilterInput(column.id, $any($event.target).value)" />
        </ng-template>
      </div>
    </div>

    <div class="table-body">
      <ng-container *ngFor="let row of model.rows; trackBy: trackRow">
        <div *ngIf="!isProjectRow(row)" class="section-header-row">
          <div class="section-header-cell">{{ row.label }}</div>
        </div>

        <div
          *ngIf="isProjectRow(row)"
          class="project-row"
          [class.row-selected]="selectedKey !== null && selectedKey === $any(row).key"
          [style.grid-template-columns]="gridTemplateColumns"
          (click)="onSelect($any(row))">
          <div
            class="project-cell"
            [ngClass]="columnClassAt(i)"
            [class.cell-stand-in]="$any(row).standIn?.[i]"
            *ngFor="let cell of $any(row).cells; let i = index; let first = first"
          >
            <!-- Precomputed text is the default and the fast path. A column only
                 takes the template branch if a consumer projected one for it. -->
            <ng-container *ngIf="templateFor(model.columns[i].id) as cellTpl; else plainCell">
              <ng-container
                *ngTemplateOutlet="cellTpl; context: { $implicit: $any(row).data, value: cell }">
              </ng-container>
            </ng-container>
            <ng-template #plainCell>{{ cell }}</ng-template>
            <button
              *ngIf="first && showShareLink"
              type="button"
              class="copy-link-btn"
              (click)="onCopyLink($any(row), $event)"
              [title]="'Copy a link to ' + $any(row).data.ProjectName">
              {{ shareLinkCopiedFor === $any(row).data.ProjectName ? '✓ Copied' : '🔗' }}
            </button>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
